<template>
  <a-spin :spinning="appState.editorLoading">
    <div class="layers" :class="{ disabled: appState.currentMenuAction === 'crop' }">
      <!-- {{ layers }}== -->
      <!-- <a-alert type="info" closable v-if="layers.length && showTip" @close="hideLayerSortTip">
        <template #message>
          <div class="text-3">出现遮挡时，按住元素前的图标拖动，调整层级</div>
        </template>
      </a-alert> -->
      <a-menu :selectedKeys="appState.isGrouping ? appState.groupUids : [appState.selectedObjectUid]" @click="onChange">
        <draggable
          class="J-layer"
          :model-value="layers"
          item-key="$$uid"
          @end="onDragEnd"
          handle=".handle"
          v-if="layers.length"
        >
          <template #item="{ element }">
            <div @mouseenter="onMouseenter(element.$$uid)" @mouseleave="onMouseleave(element.$$uid)">
              <a-menu-item :key="element.$$uid" class="item">
                <div class="flex items-center">
                  <div class="handle mr-2">
                    <a-tooltip placement="left" :title="t('propsEditor.dragToModifyLevel')">
                      <MenuOutlined class="p1" @click.stop />
                    </a-tooltip>
                  </div>
                  <div class="line1">
                    {{ element.label }}
                  </div>
                  <div class="actions flex items-center ml-2" v-if="element.object?.selectable">
                    <a-tooltip placement="top" :title="t('propsEditor.toTop')">
                      <img
                        src="@/assets/icons/top.svg"
                        width="18"
                        height="18"
                        class="icon-top mr-2"
                        @click.stop="doSort(element.$$uid, 1)"
                      />
                    </a-tooltip>
                    <a-tooltip placement="top" :title="t('propsEditor.toBottom')">
                      <img
                        src="@/assets/icons/top.svg"
                        width="18"
                        height="18"
                        class="icon-down"
                        @click.stop="doSort(element.$$uid, -1)"
                      />
                    </a-tooltip>
                  </div>
                </div>
              </a-menu-item>
            </div>
          </template>
        </draggable>
        <div v-else-if="appState.editorLoading" class="tip">{{ t('common.loading') }}</div>
        <div class="tip" v-else>{{ t('common.nodata') }}</div>
      </a-menu>
    </div>
  </a-spin>
</template>
<script setup>
import { useStore } from 'vuex';
import { computed, ref } from 'vue';
import draggable from 'vuedraggable';
import { MenuOutlined } from '@ant-design/icons-vue';
import { getLayerSortTip, hideLayerSortTip } from '@/utils/ls';
import { getObjectByUid, getRecordState } from '@/utils';
import i18n from '@/locales/i18n';

const { t } = i18n.global;
const store = useStore();
const appState = computed(() => store.state.app);
const layerMap = {
  textbox: { selectable: true, label: item => item.text },
  path: { selectable: false, label: item => `${t('propsEditor.brushLine')}${item.$$uid}` },
  rect: { selectable: true, label: item => `${t('common.rectangle')}${item.$$uid}` },
  image: { selectable: true, label: item => `${t('common.image')}${item.$$uid}` },
};
const showTip = ref(getLayerSortTip());
const layers = computed(() => {
  const { objectUIDs, objectMap } = appState.value;
  return objectUIDs
    .map(uid => {
      const object = objectMap[uid];
      if (!object) return {};
      try {
        const { type, $$uid } = object;
        const itemConfig = layerMap[type];
        return { $$uid, type, object, label: itemConfig.label(object), selectable: itemConfig.selectable };
      } catch (err) {
        console.error(err);
        return {};
      }
    })
    .reverse();
});

const doSort = (uid, dir) => {
  const object = appState.value.objectMap[uid];
  if (dir === 1) {
    object.bringToFront();
  }
  if (dir === -1) {
    object.sendToBack();
  }

  object.$$manualSorted = 1;
  store.commit(
    'app/SET_objectUIDs',
    $XJCanvas.getObjects().map(i => i.$$uid)
  );
  store.commit('app/ADD_MANUAL_SORTED_UIDS', object.$$uid);
  store.dispatch('record/addState', getRecordState(appState.value));
  $XJCanvas.renderAll();
};

const onMouseenter = uid => {
  const object = getObjectByUid(uid);
  if (object) {
    object._renderControls(object.canvas.contextTop, {
      hasControls: false,
    });
  }
};
const onMouseleave = uid => {
  const object = getObjectByUid(uid);
  if (object) {
    object.canvas.contextTop && object.canvas.clearContext(object.canvas.contextTop);
  }
};

const onChange = item => {
  const { key } = item;
  const object = appState.value.objectMap[key] || {};
  // 如果是取消翻译笔刷，不响应事件
  if (object.$$isDraw2CancelTranslated || !object.selectable) return;
  const { isGrouping } = appState.value;
  if (isGrouping) {
    // todo：点击添加一个选中的元素
    // const group = $XJCanvas.getActiveObjects();
    // const object = $XJCanvas.getObjects().filter(i => i.$$uid === key)[0];
    // if (object) {
    //   group.push(object);
    //   let selectionGroup = new fabric.ActiveSelection(group);
    //   $XJCanvas.add(selectionGroup);
    //   $XJCanvas.setActiveObject(selectionGroup);
    // }
    // object && $XJCanvas.setActiveObject(object);
    // store.dispatch('app/setGroupState', true);
  } else {
    store.dispatch('app/manualSelectObject', key);
    store.dispatch('app/setCurrentPropsEditorType', object.type);
  }
};

const onDragEnd = e => {
  const len = layers.value.length;
  const [oldIndex, newIndex] = [len - e.oldIndex - 1, len - e.newIndex - 1];
  console.log('onDragEnd', [...appState.value.objectUIDs]);
  console.log('onDragEnd', oldIndex, '=>', newIndex);
  const { object } = layers.value[e.oldIndex];
  object.moveTo(newIndex);
  object.$$manualSorted = 1;
  console.log('onDragEnd object', object);
  store.commit(
    'app/SET_objectUIDs',
    $XJCanvas.getObjects().map(i => i.$$uid)
  );

  store.commit('app/ADD_MANUAL_SORTED_UIDS', object.$$uid);
  store.dispatch('record/addState', getRecordState(appState.value));
  console.log('onDragEnd', [...appState.value.objectUIDs]);
};
</script>
<style lang="less" scoped>
.handle {
  cursor: move;
}

.icon-top {
  transform: rotate(180deg);
}
.layers {
  min-height: 88px;

  ::v-deep(.item) {
    padding: 0 5px;
    .actions {
      display: none;
    }
    &:hover {
      .actions {
        display: block;
      }
    }
  }
}

.tip {
  padding: 12px 0;
  color: #999;
  font-size: 12px;
  text-align: center;
}
</style>
